// extracted by mini-css-extract-plugin
export default {"content":"Lockable_content__4QrAg","description":"Lockable_description__1Htt9"};